import React from 'react'
import Index from '../Pages/Index'
import '../Pages/main.css'
import '../Pages/util.css'


function Home() {
  return (
   <>
   
  <Index/>
   </>
  )
}

export default Home
